module.exports = __webpack_public_path__ + "img/img-a2e94f55.da183c65.png";